import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Routers } from "./Constant";
import React, { useState, useEffect } from "react";
import { CardSection } from "../components/whykeyzi_card/Why_Keyzi_Card";
import { SchoolDetail } from "../pages/SchoolDetail";
import { CardDetail } from "../components/carddetail/CardDetail";
import { InstructorDetail } from "../pages/InstructorDetail";
import { Home } from "../pages/HomePage";
import { SiteTwo } from "../pages/SiteTwo";
import { Header } from "../components/header/Header";
import { Manual } from "../components/manual/Manual";
import { PublicRoutes } from "./PublicRoutes";
import { DashboardRoutes } from "./DashboardRoutes";
import { Progress } from "../components/Progress/Progress";
import { Login } from "../components/login/Login";
import { Footer } from "../components/footer/Footer";
import { AboutInstructor } from "../components/aboutinstructor/AboutInstructor";
import { Wallet } from "../components/dashboard/wallet/Wallet";
import { Profile } from "../components/dashboard/profile/Profile";
import { Booking } from "../components/dashboard/booking/Booking";
import { TransectionHistory } from "../components/dashboard/transactionhistory/TansectionHistory";
import { Changepwd } from "../components/dashboard/changepassword/Changepwd";
import { DashBoardMain } from "../components/dashboard/dashboardmain/DashBoardMain";
import ScrollTop from "../ScrollTop";
import { SignupInstructor } from "../pages/SignUpInstructor";
import { FindInstructor } from "../components/findInstructor/FindInstructor";
import { SignUpLearner } from "../pages/SignUpLearner";
import { ForgotPassword } from "../components/login/ForgotPassword";
import { ResetPassword } from "../components/login/ResetPassword";
import PageNotFound from "../pages/PageNotFound";
import { BookingDetails } from "../components/dashboard/booking/BookingDetails";
import { Contact } from "../components/contactus/Contact";
import { UpdateBooking } from "../components/dashboard/booking/UpdateBooking";
import { CorporateSiteOne } from "../pages/CorporateSiteOne";
import { CorporateSiteTwo } from "../pages/CorporateSiteTwo";
import Conquer from "../pages/Conquer";
import Unlock from "../pages/Unlock";
import Embark from "../pages/Embark";
import Guide from "../pages/Guide";
import Rediscover from "../pages/Rediscover";
import License from "../pages/License";
import Navigating from "../pages/Navigating";
import SiteOne from "../pages/SiteOne";
import Support from "../components/support/Support";
import SupportDetails from "../components/support/SupportDetail";
import DynamicPage from "../DynamicPage";
import axios from "axios";
import DrivingLessons from "../pages/DrivingLessons";
import TestPackages from "../pages/TestPackages";
import GiftVoucher from "../pages/GiftVoucher";
import BecomeInstructor from "../pages/BecomeInstructor";
import InternationalsConversions from "../pages/InternationalsConversions";
import RefreshersCourses from "../pages/RefreshersCourses";

// Other imports like Routers, specific pages, etc., remain as in your original code

export const Router = () => {
  const [referal, setReferal] = useState(false);
  const [dynamicRoutes, setDynamicRoutes] = useState([]);
  const [loading, setLoading] = useState(true); // Initial state is loading
  const [update, setUpdate] = useState("");
  const currentURL = window.location.href;
  const url = currentURL;
  const domain = new URL(url).hostname;
  
  useEffect(() => {
    if (currentURL.includes("/referal-code")) {
      setReferal(true);
    }
  }, [currentURL]);

  // Fetch dynamic routes
  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        setLoading(true); // Start the loader
        const response = await axios.get(`https://keyzi.com.au/keyzi-admin/api/get-page?url=keyzi.com.au`);
        const routes = response.data.map((page) => ({
          path: `/${page.name.replaceAll(" ", "-").toLowerCase()}`,
          element: <DynamicPage dynamicPages={response.data} />,
          key: page.id,
          pagename: page.name,
          page_type:page.page_type
        }));

        // Add a route for the home page
        routes.unshift({
          path: '/xcsfvt', // Assuming this is the home route
          element: <DynamicPage dynamicPages={response.data} />,
          key: 'home',
          pagename: 'Home'
        });

        setDynamicRoutes(routes);
      } catch (error) {
        console.error("Error fetching routes:", error);
      } finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchRoutes();
  }, []);

  // Conditionally render the loader
  if (loading) {
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
      </div>
    ); // Replace this with your custom loader if desired
  }

  // Public and Dashboard Routes as in your original code
  const publicRoutes = [
    { path: Routers.Home, element: <PublicRoutes element={Home} /> },
    { path: Routers.WhyKeyzi, element: <PublicRoutes element={CardSection} /> },
    { path: Routers.OurInstructor, element: <PublicRoutes element={InstructorDetail} /> },
    { path: Routers.School, element: <PublicRoutes element={SchoolDetail} /> },
    { path: Routers.Contact, element: <PublicRoutes element={Contact} /> },
    { path: Routers.SignUpLearner, element: <PublicRoutes element={SignUpLearner} /> },
    { path: Routers.Manual, element: <PublicRoutes element={Manual} /> },
    { path: Routers.MoreInfo, element: <PublicRoutes element={AboutInstructor} /> },
    { path: Routers.Login, element: <PublicRoutes element={Login} /> },
    { path: Routers.SignUpInstructor, element: <PublicRoutes element={SignupInstructor} /> },
    { path: Routers.findanInstructor, element: <PublicRoutes element={FindInstructor} /> },
    { path: Routers.ForgotPasword, element: <PublicRoutes element={ForgotPassword} /> },
    { path: Routers.ResetPassoword, element: <PublicRoutes element={ResetPassword} /> },
    { path: Routers.JoinKeyzi, element: <PublicRoutes element={CardDetail} /> },
    // { path: Routers.LandingPage, element: <PublicRoutes element={LandingPage} /> },
    { path: Routers.conquer, element: <PublicRoutes element={Conquer} /> },
    { path: Routers.unlock, element: <PublicRoutes element={Unlock} /> },
    { path: Routers.embark, element: <PublicRoutes element={Embark} /> },
    { path: Routers.guide, element: <PublicRoutes element={Guide} /> },
    { path: Routers.rediscover, element: <PublicRoutes element={Rediscover} /> },
    { path: Routers.license, element: <PublicRoutes element={License} /> },
    { path: Routers.navigating, element: <PublicRoutes element={Navigating} /> },
    { path: Routers.ManualState, element: <PublicRoutes element={Manual} /> },
    { path: Routers.ManualCity, element: <PublicRoutes element={Manual} /> },
    { path: Routers.site1, element: <PublicRoutes element={SiteOne} /> },
    { path: Routers.support, element: <PublicRoutes element={Support} /> },
    { path: Routers.supportDetails, element: <PublicRoutes element={SupportDetails} /> },
    { path: Routers.supportDetailscontent, element: <PublicRoutes element={SupportDetails} /> },
    { path: Routers.drivinglessonsnew, element: <PublicRoutes element={DrivingLessons} /> },
    { path: Routers.testPackagesnew, element: <PublicRoutes element={TestPackages} /> },
    { path: Routers.giftvoucher, element: <PublicRoutes element={GiftVoucher} /> },
    { path: Routers.becomeAInstructor, element: <PublicRoutes element={BecomeInstructor} /> },
    { path: Routers.internationalsConversions, element: <PublicRoutes element={InternationalsConversions} /> },
    { path: Routers.refresherCourses, element: <PublicRoutes element={RefreshersCourses} /> },
    { path: Routers.Progress, element: <PublicRoutes element={Progress} /> },


  ];

  const dashboardRoutes = [
    { path: Routers.Dashboard, element: <DashboardRoutes element={DashBoardMain} /> },
    { path: Routers.Wallet, element: <DashboardRoutes element={Wallet} /> },
    { path: Routers.Profile, element: <DashboardRoutes element={Profile} /> },
    { path: Routers.Booking, element: <DashboardRoutes element={Booking} /> },
    { path: Routers.Transaction, element: <DashboardRoutes element={TransectionHistory} /> },
    { path: Routers.ChangePassword, element: <DashboardRoutes element={Changepwd} /> },
    { path: Routers.bookingDetails, element: <DashboardRoutes element={BookingDetails} /> },
    // { path: Routers.feedbacklearner, element: <DashboardRoutes element={FeedBackPage} /> },
    { path: Routers.updateBooking, element: <DashboardRoutes element={UpdateBooking} /> },
    { path: Routers.site2, element: <SiteTwo /> },
    { path: Routers.CorporateSiteOne, element: <CorporateSiteOne /> },
    { path: Routers.CorporateSiteTwo, element: <CorporateSiteTwo /> }
  ];

  const updateDataHandler = (data) => {
    setUpdate(data);
  };

  return (
    <BrowserRouter>
      <ScrollTop />
      {!referal && <Header dynamicRoutes={dynamicRoutes} update={update} />}
      <Routes>
        {/* Dynamic Routes */}
        {dynamicRoutes.map((route) => (
          <Route path={route.path} element={route.element} key={route.key} />
        ))}

        {/* Public Routes */}
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {/* Dashboard Routes */}
        {dashboardRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {/* Fallback for unmatched routes */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {!referal && <Footer dynamicRoutes={dynamicRoutes} />}
    </BrowserRouter>
  );
};
